import React from 'react'
import { StaticImage } from 'gatsby-plugin-image'

export default function PageHero({ title }) {
  return (
    <div className="bg-black relative h-[360px] overflow-hidden">
      <div className="relative z-10 text-center w-full h-full flex items-center justify-center">
        <h1 className="uppercase">{title}</h1>
      </div>
      <div className="absolute inset-0 w-full h-full">
        <StaticImage
          src="../../../images/backgrounds/donate-background.png"
          alt=""
          className="w-full h-full"
        />
      </div>
    </div>
  )
}
